import { render, staticRenderFns } from "./sch_tjsheet.vue?vue&type=template&id=59a96624"
import script from "./sch_tjsheet.vue?vue&type=script&lang=js"
export * from "./sch_tjsheet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX-JYJ\\WEB\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports